import React, {Component, PropTypes} from 'react'
import OpenTicketAddressCard from '../../../lib/ticket/components/OpenTicketAddressCard'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import i18n from '../i18n'
import LoaderButton from '../../core/components/LoaderButton'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {createValidator, OpenTicketCmd} from '../models'
import {
    CORRECT_LOCATION_REFERENCE_CMD_UPDATED,
    updateCorrectLocationReferenceCmd,
    updateOpenTicketCmd,
} from '../actions'
import {connect} from 'react-redux'
import OpenTicketLayout from './OpenTicketLayout'
import cache from '../../core/cache'
import {addressField} from '../../core/google/places'

const schemaCache = cache()

function selectSchema(target, {step}) {
    const schema = OpenTicketCmd.selectSchema(target)

    return schemaCache([schema, step], () => {
        if (step == 0.1) {
            return {
                ...schema,
                properties: {
                    company: schema.properties.company,
                    locationRef: schema.properties.locationRef,
                    ticket: {
                        ...schema.properties.ticket,
                        properties: {
                            callerz: schema.properties.ticket.properties.callerz,
                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
                            address: schema.properties.ticket.properties.address
                        },
                        required: ['callerz', 'address']
                    }
                },
                required: ['company', 'locationRef', 'ticket']
            }
        }
        return schema
    })
}


class TicketCorrectLocationReference extends Component {
    _init = (props) => {
        const {ticket, dispatch} = props
        const {clientCompany: company} = ticket && ticket.linkedEntities
        dispatch(updateCorrectLocationReferenceCmd({ticket, company, locationRef: {locationReferenceType: 'PatrimonyLocation'}}))
    }

    componentWillMount() {
        this._init(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.company !== nextProps.company) {
            this._init(nextProps)
        }
    }

    _submit = () => {
        const {cmd} = this.props
        const {ticket, locationRef} = cmd
        this.props.onSubmit({
            address: {
                ...ticket.address,
                street: [ticket.address.number, ticket.address.street].join(' ')
            },
            locationReference: {
                locationReferenceType: locationRef.locationReferenceType,
                patrimonyUid: locationRef.patrimonyUid && locationRef.patrimonyUid.uid,
                agencyUid: locationRef.agencyUid && locationRef.agencyUid.uid
            }
        })
    }

    render = () => {
        const {form, cmd, dispatch, onHide, show} = this.props

        return (

            <Modal
                bsSize='large'
                show={show}
                onHide={onHide}
            >
                <Modal.Header>
                    <Modal.Title>{i18n.interventionLocation}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OpenTicketAddressCard {...{form, cmd, dispatch}} split={true}/>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            // className={cx({disabled: !form.isValid()})}
                            onClick={this._submit}
                            >
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}
                            >
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>

            )
    }
}


TicketCorrectLocationReference = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: selectSchema,
    action: CORRECT_LOCATION_REFERENCE_CMD_UPDATED
})(TicketCorrectLocationReference)

TicketCorrectLocationReference = connect((state) => ({
    cmd: state.ticket.correctLocationReferenceCmd
}))(TicketCorrectLocationReference)

export default TicketCorrectLocationReference


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketCorrectLocationReference.js